const getDocumentStyles = ({
  fontFamily = "Times New Roman, Times, serif",
  textColor = "#1f2937",
  chipBackground = "#e3f2fd",
  chipBorder = "#90caf9",
  chipColor = "#1565c0",
  pageWidthMm = 210,
  pageHeightMm = 297,
  marginTop = 12,
  marginRight = 12,
  marginBottom = 12,
  marginLeft = 12,
  headerGap = 5,
  footerGap = 5,
} = {}) => `
    :root {
      --siis-font-family: ${fontFamily};
      --siis-text-color: ${textColor};
      --siis-chip-bg: ${chipBackground};
      --siis-chip-border: ${chipBorder};
      --siis-chip-color: ${chipColor};
      --siis-border-soft: #e5e7eb;
      --siis-muted: #6b7280;
      --siis-page-width: ${pageWidthMm}mm;
      --siis-page-height: ${pageHeightMm}mm;
      --siis-margin-top: ${marginTop}mm;
      --siis-margin-right: ${marginRight}mm;
      --siis-margin-bottom: ${marginBottom}mm;
      --siis-margin-left: ${marginLeft}mm;
      --siis-header-gap: ${headerGap}mm;
      --siis-footer-gap: ${footerGap}mm;
    }

    * {
      box-sizing: border-box;
    }

    .siis-pdf-root {
      width: var(--siis-page-width);
      background: #ffffff;
      color: var(--siis-text-color);
      font-family: var(--siis-font-family);
      position: relative;
    }

    .siis-pdf-source {
      position: absolute;
      left: -10000px;
      top: 0;
      width: calc(var(--siis-page-width) - var(--siis-margin-left) - var(--siis-margin-right));
      visibility: hidden;
      pointer-events: none;
    }

    .siis-pdf-pages {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .siis-pdf-page {
      width: var(--siis-page-width);
      height: var(--siis-page-height);
      background: #ffffff;
      overflow: hidden;
      position: relative;
    }

    .siis-pdf-page__inner {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding:
        var(--siis-margin-top)
        var(--siis-margin-right)
        var(--siis-margin-bottom)
        var(--siis-margin-left);
    }

    .siis-pdf-page__header {
      flex: 0 0 auto;
      margin-bottom: var(--siis-header-gap);
    }

    .siis-pdf-page__content {
      flex: 1 1 auto;
      min-height: 0;
      display: flow-root;
    }

    .siis-pdf-page__footer-spacer {
      flex: 0 0 var(--siis-footer-gap);
      height: var(--siis-footer-gap);
    }

    .siis-pdf-header {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 8px 0;
    }

    .siis-pdf-header__logos {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    .siis-pdf-header__logo {
      max-height: 38px;
      width: auto;
      display: block;
      object-fit: contain;
    }

    .siis-pdf-content,
    .siis-pdf-page__content {
      min-height: 200px;
      font-size: 13px;
      line-height: 1.55;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    .siis-pdf-content {
      display: flow-root;
    }

    .siis-pdf-content > :first-child,
    .siis-pdf-page__content > :first-child {
      margin-top: 0 !important;
    }

    .siis-pdf-content > :last-child,
    .siis-pdf-page__content > :last-child {
      margin-bottom: 0 !important;
    }

    .siis-pdf-content p,
    .siis-pdf-page__content p {
      margin: 0 0 10px;
    }

    .siis-pdf-content ul,
    .siis-pdf-content ol,
    .siis-pdf-page__content ul,
    .siis-pdf-page__content ol {
      margin: 0 0 10px;
      padding-left: 20px;
    }

    .siis-pdf-content .chip,
    .siis-pdf-page__content .chip {
      display: inline;
      padding: 0;
      margin: 0;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: inherit;
      font-size: inherit;
      font-weight: inherit;
      white-space: normal;
      vertical-align: baseline;
    }

    .siis-pdf-content .wizard-block,
    .siis-pdf-page__content .wizard-block {
      border: 0;
      border-radius: 0;
      background: transparent;
      padding: 0;
      margin: 0 0 10px;
      display: block;
    }

    .siis-pdf-content .wizard-block__title,
    .siis-pdf-page__content .wizard-block__title {
      display: none;
    }

    .siis-pdf-content .wizard-block__body,
    .siis-pdf-content .wizard-block__body p,
    .siis-pdf-page__content .wizard-block__body,
    .siis-pdf-page__content .wizard-block__body p {
      display: block;
      margin: 0 0 10px;
      padding: 0;
      font-weight: inherit;
      color: inherit;
    }

    .siis-pdf-content table,
    .siis-pdf-page__content table {
      width: 100%;
      border-collapse: collapse;
      margin: 8px 0;
    }

    .siis-pdf-content table,
    .siis-pdf-content th,
    .siis-pdf-content td,
    .siis-pdf-page__content table,
    .siis-pdf-page__content th,
    .siis-pdf-page__content td {
      border: 1px solid #d1d5db;
    }

    .siis-pdf-content th,
    .siis-pdf-content td,
    .siis-pdf-page__content th,
    .siis-pdf-page__content td {
      padding: 6px 8px;
      text-align: left;
      vertical-align: top;
    }

    .siis-pdf-content [data-dynamic-autofill="true"],
    .siis-pdf-content [data-dynamic-autofill="true"] *,
    .siis-pdf-content .dynamic-autofill,
    .siis-pdf-content .dynamic-autofill *,
    .siis-pdf-page__content [data-dynamic-autofill="true"],
    .siis-pdf-page__content [data-dynamic-autofill="true"] *,
    .siis-pdf-page__content .dynamic-autofill,
    .siis-pdf-page__content .dynamic-autofill * {
      color: inherit !important;
      font-family: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
      font-style: inherit !important;
      line-height: inherit !important;
      letter-spacing: inherit !important;
      text-transform: inherit !important;
    }
  `;

export { getDocumentStyles };
export default getDocumentStyles;
